module.exports = __webpack_public_path__ + "static/media/jinagna.467e9494.png";